import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const register = (data) => api.post('/api/auth/register', data);
export const login = (data) => api.post('/api/auth/login', data);
export const getMe = () => api.get('/api/auth/me');
export const sendOtp = (data) => api.post('/api/auth/send-otp', data);
export const verifyOtp = (data) => api.post('/api/auth/verify-otp', data);

// Passenger APIs
export const requestRide = (data) => api.post('/api/rides/request', data);
export const getRideHistory = () => api.get('/api/rides/history');
export const getActiveRide = () => api.get('/api/rides/active');
export const rateRide = (rideId, data) => api.post(`/api/rides/${rideId}/rate`, data);
export const getRideReceipt = (rideId) => api.get(`/api/rides/${rideId}/receipt`);

// Driver APIs
export const updateDriverStatus = (data) => api.put('/api/drivers/status', data);
export const getRideRequests = () => api.get('/api/drivers/ride-requests');
export const acceptRide = (rideId) => api.post(`/api/rides/${rideId}/accept`);
export const updateRideStatus = (rideId, data) => api.put(`/api/rides/${rideId}/status`, data);
export const getDriverEarnings = () => api.get('/api/drivers/earnings');
export const getDriverStats = () => api.get('/api/drivers/stats');

// Admin APIs
export const getAdminStats = () => api.get('/api/admin/stats');
export const getAllDrivers = () => api.get('/api/admin/drivers');
export const getAllPassengers = () => api.get('/api/admin/passengers');
export const getAllRides = () => api.get('/api/admin/rides');

export default api;